import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ProtectedRoute } from "../components/ProtectedRoute";
import Users from "../pages/users/UsersPage";
import CompanyPage from "../pages/CompanyPage";
import BulletinPage from "../pages/BulletinPage";
import ContactUs from "../pages/ContactPage";
import Survey from "../pages/survey/SurveyPage";
import Warning from "../pages/WarningPage";
import News from "../pages/news/NewsPage";
import Privacy from "../pages/PrivacyPage";
import Imprint from "../pages/ImprintPage";
import { Dashboard } from "../pages/DashboardPage";
import Document from "../pages/DocumentPage";
import AboutApp from "../pages/AboutAppPage";
import Rate from "../pages/rating/RatingPage";
import LegalNotice from "../pages/LegalNoticePage";
import TermsCondition from "../pages/TermsConditionPage";
import Wreathcard from "../pages/WreathCardPage";
import Servicecategory from "../pages/ServiceCategoryPage";
import ServiceCategoryItems from "../pages/ServiceItemsPage";
import Challenges from "../pages/ChallengesPage";
import RedeemCoins from "../pages/redeem-coins/RedeemCoinsPage";
import Guides from "../pages/GuidesPage";
import Message from "../pages/message-center/MessageCenterPage";
import Improvements from "../pages/ImprovementsPage";
import { RoleManagementPage } from "../pages/role-management";
import WelcomeEmailsPage from "../pages/welcome-emails/WelcomeEmailsPage";

export default function BasePage() {
  return (
    <Suspense fallback={<div style={{ display: "flex", justifyContent: "center", padding: 40 }}><CircularProgress /></div>}>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        {/* Dashboard — accessible to all authenticated users */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Permission-protected routes */}
        <Route path="/privacy" element={<ProtectedRoute requiredPermission="/privacy"><Privacy /></ProtectedRoute>} />
        <Route path="/imprint" element={<ProtectedRoute requiredPermission="/imprint"><Imprint /></ProtectedRoute>} />
        <Route path="/document" element={<ProtectedRoute requiredPermission="/document"><Document /></ProtectedRoute>} />
        <Route path="/about-app" element={<ProtectedRoute requiredPermission="/about-app"><AboutApp /></ProtectedRoute>} />
        <Route path="/rating" element={<ProtectedRoute requiredPermission="/rating"><Rate /></ProtectedRoute>} />
        <Route path="/legal-notice" element={<ProtectedRoute requiredPermission="/legal-notice"><LegalNotice /></ProtectedRoute>} />
        <Route path="/terms-and-conditions" element={<ProtectedRoute requiredPermission="/terms-and-conditions"><TermsCondition /></ProtectedRoute>} />
        <Route path="/users" element={<ProtectedRoute requiredPermission="/users"><Users /></ProtectedRoute>} />
        <Route path="/message-center" element={<ProtectedRoute requiredPermission="/message-center"><Message /></ProtectedRoute>} />
        <Route path="/challenges" element={<ProtectedRoute requiredPermission="/challenges"><Challenges /></ProtectedRoute>} />
        <Route path="/company" element={<ProtectedRoute requiredPermission="/company"><CompanyPage /></ProtectedRoute>} />
        <Route path="/post" element={<ProtectedRoute requiredPermission="/post"><BulletinPage /></ProtectedRoute>} />
        <Route path="/contact" element={<ProtectedRoute requiredPermission="/contact"><ContactUs /></ProtectedRoute>} />
        <Route path="/survey" element={<ProtectedRoute requiredPermission="/survey"><Survey /></ProtectedRoute>} />
        <Route path="/warning" element={<ProtectedRoute requiredPermission="/warning"><Warning /></ProtectedRoute>} />
        <Route path="/news" element={<ProtectedRoute requiredPermission="/news"><News /></ProtectedRoute>} />
        <Route path="/wreath" element={<ProtectedRoute requiredPermission="/wreath"><Wreathcard /></ProtectedRoute>} />
        <Route path="/service-category" element={<ProtectedRoute requiredPermission="/service-category"><Servicecategory /></ProtectedRoute>} />
        <Route path="/service-category-items" element={<ProtectedRoute requiredPermission="/service-category-items"><ServiceCategoryItems /></ProtectedRoute>} />
        <Route path="/redeem-coins" element={<ProtectedRoute requiredPermission="/redeem-coins"><RedeemCoins /></ProtectedRoute>} />
        <Route path="/guides" element={<ProtectedRoute requiredPermission="/guides"><Guides /></ProtectedRoute>} />
        <Route path="/improvements" element={<ProtectedRoute requiredPermission="/improvements"><Improvements /></ProtectedRoute>} />

        {/* SuperAdmin-only route */}
        <Route path="/role-management" element={<ProtectedRoute requiredRole="superadmin"><RoleManagementPage /></ProtectedRoute>} />
        <Route path="/welcome-emails" element={<ProtectedRoute requiredRole="superadmin"><WelcomeEmailsPage /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/error/error-v6" replace />} />
      </Routes>
    </Suspense>
  );
}
